import PropTypes from 'prop-types';
import React, { memo, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';

import style from './style.module.css';

/**
 * Vertical collapse with Bootstrap 3 like height animation.
 *
 * @param props.isOpen {Boolean} Whether content is expanded.
 * @param props.unmountOnExit {Boolean} Unmount children after collapse animation ends.
 */
const CollapseComponent = ({ isOpen, unmountOnExit = false, className, children, ...rest }) => {
  const [isRendered, setIsRendered] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setIsRendered(true);
    }
  }, [isOpen]);

  const handleTransitionEnd = useCallback(
    event => {
      if (event.target === event.currentTarget && !isOpen) {
        setIsRendered(false);
      }
    },
    [isOpen],
  );

  const hasChildren = !unmountOnExit || isOpen || isRendered;

  return (
    <div
      {...rest}
      className={classNames(style.host, { [style.open]: isOpen }, className)}
      onTransitionEnd={handleTransitionEnd}
    >
      <div className={style.inner}>{hasChildren ? children : null}</div>
    </div>
  );
};

CollapseComponent.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  unmountOnExit: PropTypes.bool,
};

export const Collapse = memo(CollapseComponent);
